'use strict';

var favoriteClass = 'proofing-icon--heart-full';
var notFavoriteClass = 'proofing-icon--heart-empty';

var getClass = function(isFavorite) {

	if (isFavorite) {

		return favoriteClass;

	}

	return notFavoriteClass;
};

var getClasses = function() {

	return favoriteClass + ' ' + notFavoriteClass;

};

var getToolTip = function(isFavorite) {

	if (isFavorite) {

		return window.pbizServer.content.removeFavorite;

	}

	return window.pbizServer.content.addFavorite;

};

// Explicitly toggle the favorite classes on or off.
var toggleClass = function($el, isFavorite) {

	if (isFavorite) {

		$el.removeClass(notFavoriteClass);
		$el.addClass(favoriteClass);

	} else {

		$el.removeClass(favoriteClass);
		$el.addClass(notFavoriteClass);

	}

};

// Toggles both classes at the same time. Useful when you know the correct class
// was originally applied.
var toggleClasses = function($el) {

	$el.toggleClass(getClasses());

};

var toggleToolTip = function($el, isFavorite) {

	$el.attr('title', getToolTip(isFavorite));

};

module.exports = {
	getClass: getClass,
	getToolTip: getToolTip,
	toggleClass: toggleClass,
	toggleClasses: toggleClasses,
	toggleToolTip: toggleToolTip
};
